export default __webpack_public_path__ + "static/media/create_gist.e34ecee1.svg";